import { useEffect, useState } from 'react';
import { API } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';

import {
  DashboardInvestmentContainer,
  Banner,
  DashboardInvestmentInfo,
  DashboardInvestmentTable
} from './investment.styles';
import { fetchPersonalInformation } from 'src/store/Profile/profile.slice';
import ModalCompanyDetailInvestPay from 'src/components/shared/modals/companyDetailInvestPay/companyDetailInvestPay';

import Investment from './subComponents/investment';
import { getInvestor_Profile } from 'src/graphql/customized_queries';

export default function DashboardInvestment() {
  const dispatch = useDispatch();
  // const [selected, setSelected] = useState(false);
  const user = useSelector((state) => state.user.currentUser);
  const [companyDetailInvestPay, setCompanyDetailInvestPay] = useState(false);
  const [investorData, setInvestorData] = useState(null);
  const personalInformation = useSelector((state) => state.profile.personalInformation);
  const stp = personalInformation?.data?.getInvestor?.STP;
  const allBids = personalInformation?.data?.getInvestor?.investments?.items || [];

  useEffect(() => {
    if (user.id) {
      dispatch(fetchPersonalInformation(user.id));
    }
  }, [user.id, dispatch]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await API.graphql({
          query: getInvestor_Profile,
          variables: { id: user.id }
        });
        setInvestorData(data.getInvestor);
      } catch (error) {
        console.error(error);
      }
    };
    fetchUserData();
  }, []);

  function formatCurrency(amount) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  }
  const compromiso = allBids.reduce((total, bid) => total + bid.compromisoInversion, 0);

  return (
    <DashboardInvestmentContainer>
      <ModalCompanyDetailInvestPay showModalCompanyDetailInvestPay={companyDetailInvestPay} />
      <Banner>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_inv_dash_investment_banner.png`}
            alt="Finsphera inversiones"
          />
        </figure>
        <h2>Panel de inversiones</h2>
        <p>
          Aquí podrás encontrar toda la información de tus inversiones realizadas a través de la
          plataforma de FinSphera.
        </p>
      </Banner>
      <DashboardInvestmentInfo>
        <div>
          <h3>Saldo disponible</h3>
          <h3>Total invertido activo:</h3>
          <h3>Saldo total</h3>
        </div>
        <div>
          <p>{formatCurrency(stp?.recursosDisponibles ? stp?.recursosDisponibles : '-')}</p>
          <p>{formatCurrency(compromiso ? compromiso : '0')}</p>
          <p>
            {stp?.recursosDisponibles + compromiso
              ? formatCurrency(stp?.recursosDisponibles + compromiso)
              : '-'}
          </p>
        </div>
      </DashboardInvestmentInfo>
      <DashboardInvestmentTable>
        <tbody>
          {/* <thead> */}
          <tr>
            <th>Campaña</th>
            <th>ID solicitud</th>
            <th>Estado solicitud</th>
            <th>Monto de solicitud</th>
            <th>Fecha de término</th>
            <th>Detalles</th>
            <th>Opciones inversión</th>
          </tr>
          {/* </thead> */}
          {allBids.length < 0 ? (
            allBids?.map((lB, index) => <Investment listBids={lB} keys={index} key={index} />)
          ) : (
            <tr>
              <td colSpan="7">
                <h2>No tienes registrada ninguna inversión aún</h2>
              </td>
            </tr>
          )}
        </tbody>
      </DashboardInvestmentTable>
      <h3>
        Recuerda que puedes cancelar tus compromisos de inversión siempre y cuando las campañas aún
        se encuentren activas, si están cerradas no será posible realizar este proceso.
      </h3>
    </DashboardInvestmentContainer>
  );
}
